module.exports = __webpack_public_path__ + "static/st-5-cf50abc0ab5620445e2d8ad025f475d1.jpg";